import { tokens } from "@core/theme/tokens";

// Exact portal-only values from portal.json and prototype/components.md.
export const portalPrimitiveValues = {
  badge: {
    padding: "6px 11px",
    radius: 999,
    font: `600 10.5px/1 ${tokens.font.ui}`,
  },
  modal: {
    zIndex: 1000,
    overlay: "rgba(6,6,7,0.7)",
    surface: "#16161A",
    padding: 24,
    radius: 18,
    shadow: "0 40px 90px rgba(0,0,0,0.6)",
  },
  // Sheet del prototipo (admin.jsx:638), renombrado SidePanel. Por debajo de
  // `modal.zIndex` a propósito: un Modal abierto sobre la ficha (agregar
  // vehículo, confirmar baja) debe quedar encima del panel lateral.
  sidePanel: {
    zIndex: 900,
    overlay: "rgba(6,6,7,0.62)",
    width: 920,
    background: "linear-gradient(180deg,#141417 0%,#101012 100%)",
    shadow: "-30px 0 80px rgba(0,0,0,0.55)",
  },
  segmented: {
    gap: 4,
    padding: 4,
    radius: 999,
    optionPadding: "9px 18px",
    optionFont: `600 12.5px ${tokens.font.ui}`,
    disabledOpacity: 0.5,
  },
  feedback: {
    gap: 8,
    padding: "48px 20px",
    maxWidth: 320,
    titleFont: `600 14px ${tokens.font.ui}`,
    bodyFont: `400 12.5px ${tokens.font.ui}`,
  },
  toast: {
    zIndex: 1100,
    bottom: 30,
    duration: 2600,
    // T2 (2026-09-19, qa-bug-matrix-2026-09.md §6): un identificador de
    // correlación de 36 caracteres no se copia en 2.6s. El tono de error
    // queda casi 5x más tiempo para que el operador lo lea y lo copie antes
    // de que se descarte solo.
    errorDuration: 12000,
    gap: 8,
    padding: "11px 15px",
    radius: 999,
    // Ancho máximo del contenedor completo del toast (mensaje + chip de
    // correlación + botón Copiar en el tono de error).
    maxWidth: "min(640px, 92vw)",
    font: `600 12.5px ${tokens.font.ui}`,
    copyButtonPadding: "4px 9px",
    copyButtonFont: `600 11px ${tokens.font.ui}`,
    correlationFont: `600 11.5px ui-monospace, SFMono-Regular, Menlo, monospace`,
  },
  toggle: { width: 44, height: 25, thumb: 19, inset: 2, radius: 999 },
  // Checkbox compartido (revisión en vivo 2026-09-22, punto #4B). Forma de
  // chip: mismo `padding`/`radius`/tipografía que `.chip` (base.css:106-120) y
  // el mismo par seleccionado/no seleccionado que ya usa `SegmentedControl`
  // (surface3 + line2 vs surface + line). Nada de champagne: ese acento es
  // exclusivo de recompensas y logros (DESIGN-TOKENS.md §1.4).
  checkbox: {
    padding: "9px 14px",
    radius: 999,
    gap: 9,
    font: `600 12px/1 ${tokens.font.ui}`,
    boxSize: 16,
    boxRadius: 5,
    checkSize: 11,
    disabledOpacity: 0.5,
  },
  // Tooltip propio (revisión en vivo 2026-09-22, punto #10A). Por encima de
  // `toast.zIndex` porque un botón de acción con tooltip puede vivir dentro de
  // un `Modal` (1000) y no debe quedar tapado por el panel ni por un toast.
  tooltip: {
    zIndex: 1200,
    padding: "6px 10px",
    radius: 9,
    gap: 8,
    maxWidth: 260,
    font: `500 11.5px/1.4 ${tokens.font.ui}`,
  },
  // Regiones del `Modal` partido en header fijo / cuerpo scrolleable / pie fijo
  // (revisión en vivo 2026-09-22, punto #3). El cuerpo conserva el `padding:
  // 24` histórico; header y pie lo mantienen a los lados y lo recortan contra
  // el divisor para que el contenido no quede flotando.
  modalRegions: {
    headerPadding: "24px 24px 16px",
    bodyPadding: "20px 24px",
    footerPadding: "16px 24px 24px",
  },
  impact: {
    width: 660,
    noticePadding: "10px 12px",
    noticeRadius: tokens.radius.sm,
  },
} as const;
